// ============================================================
// caseDob.ts — THE date of birth a case uses (pure; caseDobTeam.test.ts).
// Mirrors backend/src/lib/caseDob.ts — keep in step. The CASE'S OWN COPY
// (what its Client details page shows) wins; when it's blank OR can't be read
// as a date (legacy free text), the live client record fills in, and
// `caseCopyUnreadable` lets the page say so. Everything where age matters
// reads this: limitation-for-minors warnings (limitationRules), the
// accident-before-DOB check, the quick view.
// `differs` = both are READABLE and not the same date (Settlement warns).
// (Audit fix 1, H3) `otherDob` = the client record's DOB when they differ;
// `limitationDob` = both, for the limitation rules (utils/limitationRules —
// the one giving the EARLIER estimate is used, and the box says so).
// ============================================================
import { textDateToIso } from './civilDate'

const filled = (v: string | null | undefined): string | null => (typeof v === 'string' && v.trim() !== '' ? v : null)

export const caseDobOf = (caseCopyRaw: string | null | undefined, clientRecordRaw: string | null | undefined): {
  dob: string | null; otherDob: string | null; limitationDob: { dob: string | null; otherDob: string | null }; caseCopy: string | null; clientRecord: string | null; differs: boolean; caseCopyUnreadable: boolean
} => {
  const caseCopy = filled(caseCopyRaw)
  const clientRecord = filled(clientRecordRaw)
  const caseIso = caseCopy ? textDateToIso(caseCopy) : null
  const recordIso = clientRecord ? textDateToIso(clientRecord) : null
  const dob = caseIso ? caseCopy : clientRecord
  const differs = !!caseIso && !!recordIso && caseIso !== recordIso
  const otherDob = differs ? clientRecord : null
  return {
    dob,
    otherDob,
    limitationDob: { dob, otherDob },
    caseCopy,
    clientRecord,
    differs,
    caseCopyUnreadable: !!caseCopy && !caseIso,
  }
}
